import { Box as BoxComponent } from './Box';
import { BoxSkeleton } from './Skeleton';
export var Box = Object.assign(BoxComponent, {
  // Assigning arbitrary static props to a component makes ts unhappy. Using Object.assign works, and actually semantically makes
  // sense as we're creating a compound component. See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-894053907
  Skeleton: BoxSkeleton
});
//# sourceMappingURL=index.js.map